const collegeRankingsDashboardPermissions = (
  action,
  permissions,
  institutionId,
  year,
) => {
  if (
    action === 'collegeRankingsDashboard:viewPage' &&
    permissions[institutionId].some((item) =>
      [
        `COLLEGE_RANKINGS_DASHBOARD_${year}`,
        `COLLEGE_RANKINGS_DASHBOARD_RELEASE_${year}`,
      ].includes(item),
    )
  ) {
    return true;
  }

  return false;
};

module.exports = {
  collegeRankingsDashboardPermissions,
};
